exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".component---1pwvo {\n  padding: 50px 0; }\n  .component---1pwvo .icon-container---3zMWn {\n    width: 180px;\n    height: 180px;\n    background: #d6d6d6;\n    border-radius: 50%;\n    margin: auto; }\n  .component---1pwvo .icon-container---3zMWn > span {\n      display: block;\n      width: 100%;\n      height: 100%; }\n  .component---1pwvo .icon-container---3zMWn svg {\n      display: block;\n      width: calc(100% - 50px);\n      height: calc(100% - 50px);\n      margin-left: 25px;\n      margin-top: -10px; }\n  .component---1pwvo .icon-container---3zMWn svg path {\n        fill: #fff !important; }\n  .component---1pwvo p {\n    font-size: 26px;\n    color: #415667;\n    margin-top: 25px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---1pwvo",
	"icon-container": "icon-container---3zMWn"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./components/icon-message/icon-message.scss
// module id = ZDX+
// module chunks = 1